module.exports = __webpack_public_path__ + "img/fail.06295d97.svg";